import { Component } from "react"

/* Input Mask */
import InputMask from "@mona-health/react-input-mask"

/* Icons */
import { EyeIcon, EyeOffIcon } from "./Icons"


/* PROPS OF THE COMPONENT ITSELF — THEY NEVER REACH THE DOM NODE */
const OWN = ["label", "secure", "mask", "file", "clear", "onFocus", "onBlur", "type", "value"]

/* KEEP EVERYTHING THE INPUT UNDERSTANDS AND DROP THE REST */
const getProps = (props) => Object.keys(props).reduce((result, key) => {

    /* Check Key */
    if (!OWN.includes(key)) {
        result[key] = props[key]
    }

    return result
}, {})


/* Component Input */
class Input extends Component {

    constructor() {
        super()

        this.state = {
            focused: false,
            secured: true,
            error: "",
        }
    }

    /* Show Error */
    error = (error) => this.setState({ error })

    /* On Focus */
    onFocus = (event) => {

        /* Fields */
        const { clear, onFocus } = this.props

        /* Clear The Error Of The Form */
        if (clear !== null && clear !== undefined) {
            clear()
        }

        /* Show The Focused State */
        this.setState({ focused: true, error: "" })

        /* Pass Through */
        if (onFocus) {
            onFocus(event)
        }
    }

    /* On Blur */
    onBlur = (event) => {

        /* Fields */
        const { clear, onBlur } = this.props

        /* Clear The Error Of The Form */
        if (clear !== null && clear !== undefined) {
            clear()
        }

        /* Hide The Focused State */
        this.setState({ focused: false, error: "" })

        /* Pass Through */
        if (onBlur) {
            onBlur(event)
        }
    }

    /* Toggle The Secure Value */
    toggle = () => this.setState((state) => ({ secured: !state.secured }))


    /* Draw Error */
    _error = () => {

        /* Fields */
        const { error } = this.state

        /* Check Error */
        if (error === "") {
            return null
        }

        return <div className="form-input-error">{error}</div>
    }

    /* Draw Secure Eye */
    _eye = () => {

        /* Fields */
        const { secure } = this.props
        const { secured } = this.state

        /* Check Secure */
        if (!secure) {
            return null
        }

        return (
            <div onClick={() => this.toggle()} className="form-input-secure">
                {secured ? <EyeIcon size={17} /> : <EyeOffIcon size={17} />}
            </div>
        )
    }

    /* Draw Input */
    _input = () => {

        /* Fields */
        const { value, secure, mask, type } = this.props
        const { secured } = this.state

        /* Fields — a secure field hides the value, every other field keeps the given type */
        const _type = secure ? (secured ? "password" : "text") : (type ? type : "text")

        /* Fields */
        const props = getProps(this.props)

        /* Mask */
        if (mask) {
            return (
                <InputMask
                    {...props}
                    mask={mask}
                    value={value}
                    type={_type}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    ref={(ref) => this._box = ref}
                />
            )
        }

        /* Default */
        return (
            <input
                {...props}
                value={value}
                type={_type}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                ref={(ref) => this._box = ref}
            />
        )
    }

    render = () => {

        /* Fields */
        const { label, value, file, secure, disabled } = this.props
        const { focused, error } = this.state

        /* Fields — the label rises as soon as the field is touched or already filled */
        const raised = focused || (value !== null && value !== undefined && `${value}` !== "")

        /* Fields */
        const className = [
            "form-input",
            raised ? "form-input-focused" : "",
            focused ? "active" : "",
            error !== "" ? "error" : "",
            secure ? "secure" : "",
            disabled ? "disabled" : "",
        ].filter((item) => item).join(" ")

        /* File — the label of a file field always stays up */
        if (file) {
            return (
                <div className="form-input form-input-focused file">
                    <div className="form-input-label">{label}</div>
                    <input {...getProps(this.props)} type="file" />
                </div>
            )
        }

        return (
            <div className={className}>

                {/* Label */}
                <div className="form-input-label">{label}</div>

                {/* Draw Input */}
                {this._input()}

                {/* Draw Secure Eye */}
                {this._eye()}

                {/* Draw Error */}
                {this._error()}

            </div>
        )
    }

}

export default Input
